// extracted by mini-css-extract-plugin
export default {"profileReportsSection":"ProfileEmployees_profileReportsSection__RhsMN","profileReportsList":"ProfileEmployees_profileReportsList__fzktq"};